import { render, staticRenderFns } from "./leave.vue?vue&type=template&id=8e67f0ba"
import script from "./leave.vue?vue&type=script&lang=js"
export * from "./leave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports